import {
  MarginKey,
  MarginRecord,
  NormalizedSpacingKey,
  NormalizedSpacingRecord,
  PaddingKey,
  PaddingRecord,
} from './type';

const MARGIN_KEY_MAPPING: Record<NormalizedSpacingKey, MarginKey> = {
  [NormalizedSpacingKey.Bottom]: MarginKey.Bottom,
  [NormalizedSpacingKey.Left]: MarginKey.Left,
  [NormalizedSpacingKey.Right]: MarginKey.Right,
  [NormalizedSpacingKey.Top]: MarginKey.Top,
};

const PADDING_KEY_MAPPING: Record<NormalizedSpacingKey, PaddingKey> = {
  [NormalizedSpacingKey.Bottom]: PaddingKey.Bottom,
  [NormalizedSpacingKey.Left]: PaddingKey.Left,
  [NormalizedSpacingKey.Right]: PaddingKey.Right,
  [NormalizedSpacingKey.Top]: PaddingKey.Top,
};

export function createMarginRecord(record: NormalizedSpacingRecord): MarginRecord {
  const margin: MarginRecord = {};
  Object.values(NormalizedSpacingKey).forEach(key => {
    const k = MARGIN_KEY_MAPPING[key];
    if (record[key] !== undefined) {
      margin[k] = record[key];
    }
  });
  return margin;
}

export function createPaddingRecord(record: NormalizedSpacingRecord): PaddingRecord {
  const padding: PaddingRecord = {};
  Object.values(NormalizedSpacingKey).forEach(key => {
    const k = PADDING_KEY_MAPPING[key];
    if (record[key] !== undefined) {
      padding[k] = record[key];
    }
  });
  return padding;
}
